(() => {
  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const initialize = (root) => {
    if (!root || root.dataset.technicalReady === 'true') return;
    root.dataset.technicalReady = 'true';

    const countdown = root.querySelector('[data-technical-countdown]');
    if (countdown) {
      const end = Date.parse(countdown.dateTime);
      if (Number.isFinite(end)) {
        let timer;
        const renderCountdown = () => {
          const remaining = Math.max(0, end - Date.now());
          const totalSeconds = Math.floor(remaining / 1000);
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          countdown.querySelector('[data-technical-hours]').textContent = pad(hours);
          countdown.querySelector('[data-technical-minutes]').textContent = pad(minutes);
          countdown.querySelector('[data-technical-seconds]').textContent = pad(seconds);
          if (remaining <= 0 && timer) window.clearInterval(timer);
        };
        renderCountdown();
        timer = window.setInterval(renderCountdown, 1000);
      }
    }

    if (root.dataset.technicalState === 'offline') {
      const status = root.querySelector('[data-technical-connection-status]');
      const update = () => {
        root.dataset.connection = navigator.onLine ? 'online' : 'offline';
        if (status) {
          status.hidden = !navigator.onLine;
          status.textContent = navigator.onLine
            ? (document.documentElement.lang === 'ar' ? 'تمت استعادة الاتصال' : 'Connection restored')
            : '';
        }
      };
      window.addEventListener('online', update);
      window.addEventListener('offline', update);
      update();
    }
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-technical-state]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
